import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RecruitingService } from 'src/app/api/recruiting.service';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';
import { IconService } from 'src/app/ui/icon.service';
import { UiModule } from 'src/app/ui/ui.module';

interface CallStats {
  totalCalls: number;
  totalMeetings: number;
}

@Component({
  selector: 'app-my-call-stats',
  templateUrl: './my-call-stats.component.html',
  styleUrls: ['./my-call-stats.component.scss'],
  standalone: true,
  imports: [CommonModule, UiModule]
})
export class MyCallStatsComponent implements OnInit {
  weekStats: CallStats = { totalCalls: 0, totalMeetings: 0 };
  monthStats: CallStats = { totalCalls: 0, totalMeetings: 0 };
  yearStats: CallStats = { totalCalls: 0, totalMeetings: 0 };
  
  goals: { week: number; month: number; year: number } = { week: 0, month: 0, year: 0 };
  
  weekPercentage: number = 0;
  monthPercentage: number = 0;
  yearPercentage: number = 0;
  
  currentYear: number = new Date().getFullYear();
  currentMonth: string = new Date().toLocaleString('default', { month: 'long' });

  constructor(
    private recruitingService: RecruitingService,
    private authService: LocalAuthService,
    private dataPadService: DataPadService,
    public icons: IconService
  ) {}

  ngOnInit(): void {
    const staffId = this.authService.currentUser?.newstaffId;
    
    if (staffId) {
      this.recruitingService.getMyCallStats(staffId).subscribe(response => {
        // Set goals
        this.goals = {
          week: response.myCallGoals.week ?? 0,
          month: response.myCallGoals.month ?? 0,
          year: response.myCallGoals.year ?? 0
        };

        // Week stats
        this.weekStats = {
          totalCalls: response.callCountWeek,
          totalMeetings: response.meetingCountWeek
        };
        this.weekPercentage = this.calculatePercentage(this.weekStats.totalCalls, this.goals.week);

        // Month stats
        this.monthStats = {
          totalCalls: response.callCountMonth,
          totalMeetings: response.meetingCountMonth
        };
        this.monthPercentage = this.calculatePercentage(this.monthStats.totalCalls, this.goals.month);

        // Year stats
        this.yearStats = {
          totalCalls: response.callCountYear,
          totalMeetings: response.meetingCountYear
        };
        this.yearPercentage = this.calculatePercentage(this.yearStats.totalCalls, this.goals.year);
      });
    }
  }

  private calculatePercentage(value: number, goal: number): number {
    if (goal > 0 && value > 0) {
      return Math.round((value / goal) * 100);
    }
    return 0;
  }

  updateMyCallGoals() {
    this.dataPadService.showPanel({
      panelName: 'updateMyCallGoals',
      inputData: {}
    })
  }
} 